export default function PrivacyPolicyOne() {
  return (
    <div style={{ maxWidth: '800px', padding: '0 20px', margin: '150px auto' }}>
      <p>Privacy Policy</p>

      <p>This Privacy Policy was last updated on July 22, 2020.</p>

      <p>​</p>

      <p>
        We at AUMHUM Pte, Ltd. (&ldquo;AUMHUM&rdquo;, &ldquo;we&rdquo;, &ldquo;us&rdquo;) respect
        your privacy and want you to understand how we collect, use, and share data about you. This
        Privacy Policy covers our data collection practices and describes your rights to access,
        correct, or restrict our use of your personal data.
      </p>

      <p>
        Unless we link to a different policy or state otherwise, this Privacy Policy applies when
        you visit or use the AUMHUM website, mobile applications, APIs or related services (the
        &ldquo;Services&rdquo;).
      </p>

      <p>
        By using the Services, you agree to the terms of this Privacy Policy. You shouldn&rsquo;t
        use the Services if you don&rsquo;t agree with this Privacy Policy or any other agreement
        that governs your use of the Services.
      </p>

      <p>​</p>

      <p>1. What Data We Get</p>

      <p>
        We collect certain data from you directly, like the information you enter yourself, data
        about your participation in courses, and data from third-party platforms you connect with
        AUMHUM. We also collect some data automatically, like information about your device and what
        parts of our Services you interact with or spend time using
      </p>

      <p>.</p>

      <p>1.1 Data You Provide to Us</p>

      <p>
        We may collect different data from or about you depending on how you use the Services. Below
        are some examples to help you better understand the data we collect.
      </p>

      <p>
        When you create an account and use the Services, including through a third-party platform,
        we collect any data you provide directly, including:
      </p>

      <p>Account Data</p>

      <p>
        In order to use certain features (like enrolling in a course), you need to create a user
        account. When you create or update your account, we collect and store the data you provide,
        like your email address, password, gender, and date of birth, and assign you a unique
        identifying number (&ldquo;Account Data&rdquo;).
      </p>

      <p>Profile Data</p>

      <p>
        You can also choose to provide profile information like a photo, headline, website link,
        social media profiles, or other data. Your Profile Data will be publicly viewable by others.
      </p>

      <p>Shared Content</p>

      <p>
        Parts of the Services let you interact with other users or share content publicly, including
        by posting reviews on a course page, asking or answering questions, sending messages to
        students or instructors, or posting photos or other work you upload. Such shared content may
        be publicly viewable by others depending on where it is posted.
      </p>

      <p>Course Data</p>

      <p>
        When you enroll in and take courses, we collect certain data including which courses,
        assignments and quizzes you&rsquo;ve started and completed; your exchanges with instructors,
        teaching assistants, and other students; and essays, answers to questions, and other items
        submitted to satisfy course requirements.
      </p>

      <p>Student Payment Data</p>

      <p>
        If you make purchases, we collect certain data about your purchase (such as your name and
        zip code) as necessary to process your order. You must provide certain payment and billing
        data directly to our payment processing partners, including your name, credit card
        information, billing address, and zip code. For security, AUMHUM does not collect or store
        sensitive cardholder data, such as full credit card numbers or card authentication data.
      </p>

      <p>Instructor Payment Data</p>

      <p>
        If you are an instructor, you can link your PayPal, Payoneer, Stripe or other payment
        account to the Services to receive payments. When you link a payment account, we collect and
        use certain information, including your payment account email address, account ID, physical
        address, or other data necessary for us to send payments to your account. In order to comply
        with applicable laws, we also work with trusted third parties who collect tax information as
        legally required. This tax information may include residency information, tax identification
        numbers, biographical information, and other personal information necessary for taxation
        purposes. For security, AUMHUM does not collect or store sensitive bank account information.
        The collection, use, and disclosure of your payment, billing, and taxation data is subject
        to the privacy policy and other terms of your payment account provider.
      </p>

      <p>Data About Your Accounts on Other Services</p>

      <p>
        We may obtain certain information through your social media or other online accounts if they
        are connected to your AUMHUM account. If you login to AUMHUM via Facebook or Google or
        another third-party platform or service, we ask for your permission to access certain
        information about that other account. For example, depending on the platform or service we
        may collect your name, profile picture, account ID number, login email address, location,
        physical location of your access devices, gender, birthday, and list of friends or contacts.
      </p>

      <p>
        Those platforms and services make information available to us through their APIs. The
        information we receive depends on what information you (via your privacy settings) or the
        platform or service decide to give us.
      </p>

      <p>
        If you access or use our Services through a third-party platform or service, or click on any
        third-party links, the collection, use, and sharing of your data will also be subject to the
        privacy policies and other agreements of that third party.
      </p>

      <p>Sweepstakes, Promotions, and Surveys</p>

      <p>
        We may invite you to complete a survey or participate in a promotion (like a contest,
        sweepstakes, or challenge), either through the Services or a third-party platform. If you
        participate, we will collect and store the data you provide as part of participating, such
        as your name, email address, date of birth, or phone number. That data is subject to this
        Privacy Policy unless otherwise stated in the official rules of the promotion or in another
        privacy policy. The data collected will be used to administer the promotion or survey,
        including for notifying winners and distributing rewards. To receive a reward, you may be
        required to allow us to post some of your information publicly (like on a winner&rsquo;s
        page). Where we use a third-party platform to administer a survey or promotion, the third
        party&rsquo;s privacy policy will apply.
      </p>

      <p>Communications and Support</p>

      <p>
        If you contact us for support or to report a problem or concern (regardless of whether you
        have created an account), we collect and store your contact information, messages, and other
        data about you like your name, email address, location, operating system, IP address, and
        any other data you provide or that we collect through automated means (which we cover
        below). We use this data to respond to you and research your question or concern, in
        accordance with this Privacy Policy.
      </p>

      <p>The data listed above is stored by us and associated with your account.</p>

      <p>​</p>

      <p>1.2 Data We Collect through Automated Means</p>

      <p>
        When you access the Services (including browsing courses), we collect certain data by
        automated means, including
      </p>

      <p>System Data</p>

      <p>
        Technical data about your computer or device, like your IP address, device type, operating
        system type and version, unique device identifi ers, browser, browser language, domain and
        other systems data, and platform types (&ldquo;System Data&rdquo;).
      </p>

      <p>Usage Data</p>

      <p>
        Usage statistics about your interactions with the Services, including courses accessed, time
        spent on pages or the Service, pages visited, features used, your search queries, click
        data, date and time, and other data regarding your use of the Services (&ldquo;Usage
        Data&rdquo;).
      </p>

      <p>Approximate Geographic Data</p>

      <p>
        An approximate geographic location, including information like country, city, and geographic
        coordinates, calculated based on your IP address.
      </p>

      <p>
        The data listed above is collected through the use of server log files and tracking
        technologies, as detailed in the &ldquo;Cookies and Data Collection Tools&rdquo; section
        below. It is stored by us and associated with your account.
      </p>

      <p>​</p>

      <p>2. How We Get Data About You</p>

      <p>
        We use tools like cookies, web beacons, analytics services, and advertising providers to
        gather the data listed above. Some of these tools offer you the ability to opt-out of data
        collection.
      </p>

      <p>​</p>

      <p>2.1 Cookies and Data Collection Tools</p>

      <p>
        As detailed in our&nbsp;
        <a href="https://corporate.aumhum.com/" target="_self">
          Cookie Policy
        </a>
        , Aumhum and service providers acting on our behalf (like Google Analytics and third-party
        advertisers) use server log files and automated data collection tools like cookies, tags,
        scripts, customized links, device or browser fingerprints, and web beacons (together,
        &ldquo;Data Collection Tools&rdquo;) when you access and use the Services. These Data
        Collection Tools automatically track and collect certain System Data and Usage Data (as
        detailed in Section 1) when you use the Services. In some cases, we tie data gathered
        through those Data Collection Tools to other data that we collect as described in this
        Privacy Policy.
      </p>

      <p>
        We use cookies (small files that websites send to your device to uniquely identify your
        browser or device or to store data in your browser) for things like analyzing your use of
        the Services, personalizing your experience, making it easier to log into the Services, and
        recognizing you when you return. We use web beacons (small objects that allow us to measure
        the actions of visitors and users using the Services) for things like identifying whether a
        page was visited, identifying whether an email was opened, and advertising more efficiently
        by excluding current users from certain promotional messages or identifying the source of a
        new mobile app download.
      </p>

      <p>​</p>

      <p>AUMHUM uses the following types of cookies:</p>

      <ul>
        <li>
          <p>
            Preferences: cookies that remember data about your browser and preferred settings that
            affect the appearance and behavior of the Services (like your preferred language).
          </p>
        </li>
        <li>
          <p>
            Security: cookies used to enable you to log in and access the Services; protect against
            fraudulent logins; and help detect and prevent abuse or unauthorized use of your
            account.
          </p>
        </li>
        <li>
          <p>
            Functional: cookies that store functional settings (like the volume level you set for
            video playback).
          </p>
        </li>
        <li>
          <p>
            Session State: cookies that track your interactions with the Services to help us improve
            the Services and your browsing experience, remember your login details, and enable
            processing of your course purchases. These are strictly necessary for the Services to
            work properly, so if you disable them then certain functionalities will break or be
            unavailable.
          </p>
        </li>
      </ul>

      <p>
        You can set your web browser to alert you about attempts to place cookies on your computer,
        limit the types of cookies you allow, or refuse cookies altogether. If you do, you may not
        be able to use some or all features of the Services, and your experience may be different or
        less functional.
      </p>

      <p>
        Some of the third-party partners who provide certain features on our site may also use Local
        Storage Objects (also known as flash cookies or LSOs) to collect and store data.
      </p>

      <p>​</p>

      <p>2.2 Analytics</p>

      <p>
        We use third-party browser and mobile analytics services like Google Analytics, Hotjar, and
        Intercom on the Services. These services use Data Collection Tools to help us analyze your
        use of the Services, including information like the third-party website you arrive from, how
        often you visit, events within the Services, usage and performance data, and where the
        application was downloaded from. We use this data to improve the Services, better understand
        how the Services perform on different devices and provide information that may be of
        interest to you.
      </p>

      <p>​</p>

      <p>2.3 Online Advertising</p>

      <p>
        We may use third-party advertising services like Taboola, Facebook, Google&rsquo;s ad
        services, and other ad networks and ad servers to deliver advertising about our Services on
        other websites and applications you use. The ads may be based on things we know about you,
        like your Usage Data and System Data (as detailed in Section 1), and things that these ad
        service providers know about you based on their tracking data. The ads can be based on your
        recent activity or activity over time and across other sites and services and may be
        tailored to your interests.
      </p>

      <p>
        Depending on the types of advertising services we use, they may place cookies or other
        tracking technologies on your computer, phone, or other devices to collect data about your
        use of our Services, and may access those tracking technologies in order to serve these
        tailored advertisements to you. To help deliver tailored advertising, we may provide these
        service providers with a hashed, anonymized version of your email address (in a
        non-human-readable form) and content that you share publicly on the Services.
      </p>

      <p>
        When using mobile applications you may also receive tailored in-app advertisements. Apple
        iOS, Android OS, and Microsoft Windows each provide their own instructions on how to control
        in-app tailored advertising. For other devices and operating systems, you should review your
        privacy settings or contact your platform operator.
      </p>

      <p>​</p>

      <p>3. What We Use Your Data For</p>

      <p>
        We use your data to do things like provide our Services, communicate with you, troubleshoot
        issues, secure against fraud and abuse, improve and update our Services, analyze how people
        use our Services, serve personalized advertising, and as required by law or necessary for
        safety and integrity.
      </p>

      <p>​</p>

      <p>We use the data we collect through your use of the Services to:</p>

      <p>​</p>

      <ul>
        <li>
          <p>
            Provide and administer the Services, including to display customized content and
            facilitate communication with other users;
          </p>
        </li>
        <li>
          <p>
            Process your requests and orders for courses, products, specific services, information,
            or features;
          </p>
        </li>
        <li>
          <p>Communicate with you about your account by:</p>

          <ul>
            <li>
              <p>Responding to your questions and concerns;</p>
            </li>
            <li>
              <p>
                Sending you administrative messages and information, including messages from
                instructors and teaching assistants, notifications about changes to our Service, and
                updates to our agreements;
              </p>
            </li>
            <li>
              <p>
                Sending you information and in-app messages about your progress in courses, rewards
                programs, new services, new features, promotions, newsletters, and other available
                courses (which you can opt-out of at any time);
              </p>
            </li>
            <li>
              <p>
                Sending push notifications to your wireless device to provide updates and other
                relevant messages (which you can manage from the &ldquo;options&rdquo; or
                &ldquo;settings&rdquo; page of the mobile app);
              </p>
            </li>
          </ul>
        </li>
        <li>
          <p>Manage your account preferences;</p>
        </li>
        <li>
          <p>
            Facilitate the Services&rsquo; technical functioning, including troubleshooting and
            resolving issues, securing the Services, and preventing fraud and abuse;
          </p>
        </li>
        <li>
          <p>Solicit feedback from users;</p>
        </li>
        <li>
          <p>Market and administer surveys and promotions administered or sponsored by AUMHUM;</p>
        </li>
        <li>
          <p>
            Learn more about you by linking your data with additional data through third-party data
            providers or analyzing the data with the help of analytics service providers;
          </p>
        </li>
        <li>
          <p>Identify unique users across devices;</p>
        </li>
        <li>
          <p>Tailor advertisements across devices;</p>
        </li>
        <li>
          <p>Improve our Services and develop new products, services, and features;</p>
        </li>
        <li>
          <p>Analyze trends and traffic, track purchases, and track usage data;</p>
        </li>
        <li>
          <p>Advertise the Services on third-party websites and applications;</p>
        </li>
        <li>
          <p>As required or permitted by law; or</p>
        </li>
        <li>
          <p>
            As we, in our sole discretion, otherwise determine to be necessary to ensure the safety
            or integrity of our users, employees, third parties, the public, or our Services.
          </p>
        </li>
      </ul>

      <p>​</p>

      <p>4. Who We Share Your Data With</p>

      <p>
        We share certain data about you with instructors, other students, companies performing
        services for us, our business partners, analytics and data enrichment providers, your social
        media providers, companies helping us run promotions and surveys, and advertising companies
        who help us promote our Services. We may also share your data as needed for security, legal
        compliance, or as part of a corporate restructuring. Lastly, we can share data in other ways
        if it is aggregated or de-identified or if we get your consent.
      </p>

      <p>&nbsp;</p>

      <p>
        We may share your data with third parties under the following circumstances or as otherwise
        described in this Privacy Policy:
      </p>

      <p>&nbsp;</p>

      <ul>
        <li>
          <p>
            With Your Instructors: We share data that we have about you (except your email address)
            with instructors or teaching assistants for courses you enroll in or request information
            about, so they can improve their courses for you and other students. This data may
            include things like your city, country, browser language, operating system, device
            settings, the site that brought you to AUMHUM, and your activities on AUMHUM. If we
            collect additional data about you (like age or gender), we may share that too. We will
            not share your email address with instructors or teaching assistants. We also enable our
            instructors to implement Google Analytics on their course pages to track sources of
            traffic to their courses and optimize their course pages.
          </p>
        </li>
        <li>
          <p>
            With Other Students and Instructors: Depending on your settings, your shared content and
            profile data may be publicly viewable, including to other students and instructors. If
            you ask a question to an instructor or teaching assistant, your information (including
            your name) may also be publicly viewable by other users depending on your settings.
          </p>
        </li>
        <li>
          <p>
            With Service Providers, Contractors, and Agents: We share your data with third-party
            companies who perform services on our behalf, like payment processing, data analysis,
            marketing and advertising services (including retargeted advertising), email and hosting
            services, and customer services and support. These service providers may access your
            personal data and are required to use it solely as we direct, to provide our requested
            service.
          </p>
        </li>
        <li>
          <p>
            With Business Partners: We have agreements with other websites and platforms to
            distribute our Services and drive traffic to AUMHUM. Depending on your location, we may
            share your data with these partners.
          </p>
        </li>
        <li>
          <p>
            With Analytics and Data Enrichment Services: As part of our use of third-party analytics
            tools like Google Analytics and data enrichment services like Clearbit &amp; Smartlook,
            we share certain contact information, Account Data, System Data, Usage Data (as detailed
            in Section 1), or de-identified data as needed. De-identified data means data where
            we&rsquo;ve removed things like your name and email address and replaced it with a token
            ID. This allows these providers to provide analytics services or match your data with
            publicly-available database information (including contact and social information from
            other sources). We do this to communicate with you in a more effective and customized
            manner.
          </p>
        </li>
        <li>
          <p>
            To Power Social Media Features: The social media features in the Services (like the
            Facebook Like button) may allow the third-party social media provider to collect things
            like your IP address and which page of the Services you&rsquo;re visiting, and to set a
            cookie to enable the feature. Your interactions with these features are governed by the
            third-party company&rsquo;s privacy policy.
          </p>
        </li>
        <li>
          <p>
            To Administer Promotions and Surveys: we may share your data as necessary to administer,
            market, or sponsor promotions and surveys you choose to participate in, as required by
            applicable law (like to provide a winners list or make required filings), or in
            accordance with the rules of the promotion or survey.
          </p>
        </li>
        <li>
          <p>
            For Advertising: If we decide to offer advertising in the future, we may use and share
            certain System Data and Usage Data with third-party advertisers and networks to show
            general demographic and preference information among our users. We may also allow
            advertisers to collect System Data through Data Collection Tools (as detailed in Section
            2.1), and to use this data to offer you targeted ad delivery to personalize your user
            experience (through behavioral advertising) and undertake web analytics. Advertisers may
            also share with us the data they collect about you. To learn more or opt out from
            participating ad networks&rsquo; behavioral advertising, see Section 6.1 (Your Choices
            About the Use of Your Data) below. Note that if you opt out, you&rsquo;ll continue to be
            served generic ads.
          </p>
        </li>
        <li>
          <p>
            For Security and Legal Compliance: We may disclose your data to third parties if we (in
            our sole discretion) have a good faith belief that the disclosure is:
          </p>

          <ul>
            <li>
              <p>Permitted or required by law;</p>
            </li>
            <li>
              <p>
                Requested as part of a judicial, governmental, or legal inquiry, order, or
                proceeding;
              </p>
            </li>
            <li>
              <p>
                Reasonably necessary as part of a valid subpoena, warrant, or other legally-valid
                request;
              </p>
            </li>
            <li>
              <p>
                Reasonably necessary to enforce our Terms of Use, Privacy Policy, and other legal
                agreements;
              </p>
            </li>
            <li>
              <p>
                Required to detect, prevent, or address fraud, abuse, misuse, potential violations
                of law (or rule or regulation), or security or technical issues; or
              </p>
            </li>
            <li>
              <p>
                Reasonably necessary in our discretion to protect against imminent harm to the
                rights, property, or safety of AUMHUM, our users, employees, members of the public,
                or our Services.
              </p>
            </li>
            <li>
              <p>
                We may also disclose data about you to our auditors and legal advisors in order to
                assess our disclosure obligations and rights under this Privacy Policy.
              </p>
            </li>
          </ul>
        </li>
        <li>
          <p>
            During a Change in Control: If AUMHUM undergoes a business transaction like a merger,
            acquisition, corporate divestiture, or dissolution (including bankruptcy), or a sale of
            all or some of its assets, we may share, disclose, or transfer all of your data to the
            successor organization during such transition or in contemplation of a transition
            (including during due diligence).
          </p>
        </li>
        <li>
          <p>
            After Aggregation/De-identification: we can disclose or use aggregate or de-identified
            data for any purpose.
          </p>
        </li>
        <li>
          <p>
            With Your Permission: with your consent, we may share data to third parties outside the
            scope of this Privacy Policy.
          </p>
        </li>
      </ul>

      <p>&nbsp;</p>

      <p>5. Security</p>

      <p>
        We use appropriate security based on the type and sensitivity of data being stored. As with
        any internet-enabled system, there is always a risk of unauthorized access, so it&rsquo;s
        important to protect your password and to contact us if you suspect any unauthorized access
        to your account.
      </p>

      <p>&nbsp;</p>

      <p>
        AUMHUM takes appropriate security measures to protect against unauthorized access,
        alteration, disclosure, or destruction of your personal data that we collect and store.
        These measures vary based on the type and sensitivity of the data. Unfortunately, however,
        no system can be 100% secured, so we cannot guarantee that communications between you and
        AUMHUM, the Services, or any information provided to us in connection with the data we
        collect through the Services will be free from unauthorized access by third parties. Your
        password is an important part of our security system, and it is your responsibility to
        protect it. You should not share your password with any third party, and if you believe your
        password or account has been compromised, you should change it immediately and contact&nbsp;
        <a href="mailto:privacy@aumhum.com">privacy@aumhum.com</a>&nbsp;with any concerns.
      </p>

      <p>​</p>

      <p>​</p>

      <p>6. Your Rights</p>

      <p>
        You have certain rights around the use of your data, including the ability to opt-out of
        promotional emails, cookies, and collection of your data by certain analytics providers. You
        can update or terminate your account from within our Services, and can also contact us for
        individual rights requests about your personal data. Parents who believe we&rsquo;ve
        unintentionally collected personal data about their underage child should contact us for
        help deleting that information.
      </p>

      <p>&nbsp;</p>

      <p>6.1 Your Choices About the Use of Your Data</p>

      <p>
        You can choose not to provide certain data to us, but you may not be able to use certain
        features of the Services.
      </p>

      <ul>
        <li>
          <p>
            To stop receiving promotional communications from us, you can opt-out by using the
            unsubscribe mechanism in the promotional communication you receive or by changing the
            email preferences in your account. Note that regardless of your email preference
            settings, we will send you transactional and relationship messages regarding the
            Services, including administrative confirmations, order confirmations, important updates
            about the Services, and notices about our policies.
          </p>
        </li>
        <li>
          <p>
            The browser or device you use may allow you to control cookies and other types of local
            data storage. Your wireless device may also allow you to control whether location or
            other data is collected and shared. You can manage Adobe&rsquo;s LSOs through
            their&nbsp;
            <a
              href="http://www.macromedia.com/support/documentation/en/flashplayer/help/settings_manager07.html"
              target="_blank"
              rel="noreferrer"
            >
              Website Storage Settings panel
            </a>
            .
          </p>
        </li>
        <li>
          <p>
            To get information and control cookies used for tailored advertising from participating
            companies, see the consumer opt-out pages for the&nbsp;
            <a href="http://www.networkadvertising.org/choices" target="_blank" rel="noreferrer">
              Network Advertising Initiative
            </a>
            &nbsp;and&nbsp;
            <a href="http://www.aboutads.info/choices/" target="_blank" rel="noreferrer">
              Digital Advertising Alliance
            </a>
            , or if you&rsquo;re located in the European Union, visit the&nbsp;
            <a href="http://www.youronlinechoices.eu/" target="_blank" rel="noreferrer">
              Your Online Choices
            </a>
            &nbsp;site. To opt-out of Google&rsquo;s display advertising or customize Google Display
            Network ads, visit the&nbsp;
            <a href="https://www.google.com/settings/ads" target="_blank" rel="noreferrer">
              Google Ads Settings page
            </a>
            . To opt-out of Taboola&rsquo;s targeted ads, see the Opt-out Link in their&nbsp;
            <a href="https://www.taboola.com/cookie-policy" target="_blank" rel="noreferrer">
              Cookie Policy
            </a>
            .
          </p>
        </li>
        <li>
          <p>
            To opt-out of allowing Google Analytics, Hotjar, Mixpanel, ZoomInfo, or Clearbit to use
            your data for analytics or enrichment, see the&nbsp;
            <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noreferrer">
              Google Analytics Opt-out Browser Add-on
            </a>
            ,&nbsp;
            <a href="https://www.hotjar.com/opt-out" target="_blank" rel="noreferrer">
              Hotjar Opt-Out Cookie
            </a>
            ,&nbsp;
            <a href="https://mixpanel.com/optout/" target="_blank" rel="noreferrer">
              Mixpanel Opt-Out Cookie
            </a>
            ,&nbsp;
            <a
              href="https://www.zoominfo.com/business/about-zoominfo/privacy-policy"
              target="_blank"
              rel="noreferrer"
            >
              ZoomInfo&rsquo;s policy
            </a>
            , and&nbsp;
            <a href="https://clearbit.com/privacy" target="_blank" rel="noreferrer">
              Clearbit data claiming mechanism
            </a>
            .
          </p>
        </li>
        <li>
          <p>
            To opt-out of Smartlook, please write to us at&nbsp;
            <a href="mailto:privacy@aumhum.com">privacy@aumhum.com</a>&nbsp;with the title
            &quot;Diagnostics Opt-Out&quot;
          </p>
        </li>
      </ul>

      <p>
        If you have any questions about your data, our use of it, or your rights, contact us
        at&nbsp;<a href="mailto:privacy@aumhum.com">privacy@aumhum.com</a>.
      </p>

      <p>&nbsp;</p>

      <p>6.2 Accessing, Updating, and Deleting Your Personal Data</p>

      <p>
        You can access and update your personal data that AUMHUM collects and maintains as follows:
      </p>

      <ul>
        <li>
          <p>
            To update data you provide directly, log into your account, and update your account at
            any time.
          </p>
        </li>
        <li>
          <p>To terminate your account:</p>

          <ul>
            <li>
              <p>
                If you are a student (AUMHUM User), please write to us at&nbsp;
                <a href="mailto:namaste@aumhum.com">namaste@aumhum.com</a>
              </p>
            </li>
            <li>
              <p>
                If you are an instructor, please write to us at&nbsp;
                <a href="mailto:namaste@aumhum.com">namaste@aumhum.com</a>
              </p>
            </li>
            <li>
              <p>
                Please note: even after your account is terminated, some or all of your data may
                still be visible to others, including without limitation any data that has been (a)
                copied, stored, or disseminated by other users (including in course comment); (b)
                shared or disseminated by you or others (including in your shared content); or (c)
                posted to a third-party platform. Even after your account is terminated, we retain
                your data for as long as we have a legitimate purpose to do so (and in accordance
                with applicable law), including to assist with legal obligations, resolve disputes,
                and enforce our agreements. We may retain and disclose such data pursuant to this
                Privacy Policy after your account has been terminated.
              </p>
            </li>
          </ul>
        </li>
        <li>
          <p>
            To request to access, correct, or delete your personal data, email&nbsp;
            <a href="mailto:privacy@aumhum.com">privacy@aumhum.com</a>&nbsp;or write to us at AUMHUM
            Pte. Ltd., Attn: Privacy/Legal Team, 160 Robinson Road, #20-03 SBF Center, Singapore
            068914. Please allow up to 30 days for a response. For your protection, we may require
            that the request be sent through the email address associated with your account, and we
            may need to verify your identity before implementing your request. Please note that we
            retain certain data where we have a lawful basis to do so, including for mandatory
            record-keeping and to complete transactions.
          </p>
        </li>
      </ul>

      <p>&nbsp;</p>

      <p>6.3 Our Policy Concerning Children</p>

      <p>
        We recognize the privacy interests of children and encourage parents and guardians to take
        an active role in their children&rsquo;s online activities and interests. Children under 13
        (or under 16 in the European Economic Area) should not use the Services. If we learn that
        we&rsquo;ve collected personal data from a child under those ages, we will take reasonable
        steps to delete it.
      </p>

      <p>
        Parents who believe that AUMHUM may have collected personal data from a child under those
        ages can submit a request that it be removed to&nbsp;
        <a href="mailto:privacy@aumhum.com">privacy@aumhum.com</a>.
      </p>

      <p>​</p>

      <p>​</p>

      <p>7. Jurisdiction-Specific Rules</p>

      <p>
        If you live in California, you have certain rights related to accessing and deleting your
        data, as well as learning who we share your data with. If you live in Australia, you have
        the right to make a formal complaint with the appropriate government agency. Users outside
        of the United States should note that we transfer data to the US and other areas outside of
        the European Economic Area.
      </p>

      <p>&nbsp;</p>

      <p>7.1 Users in California</p>

      <p>
        Users who are California residents have certain rights under the California Consumer Privacy
        Act, (&ldquo;CCPA&rdquo;). If you are an eligible California user, included in these rights
        are:
      </p>

      <p>&nbsp;</p>

      <ul>
        <li>
          <p>
            &ldquo;Right to Know&rdquo; &mdash; You have the right to request to know more about the
            categories and specific pieces of personal information that we have collected about you
            and access a copy of your personal information.
          </p>
        </li>
        <li>
          <p>
            &ldquo;Right to Deletion&rdquo; &mdash; You have the right to request deletion of
            personal information that we have collected about you.
          </p>
        </li>
        <li>
          <p>
            &ldquo;Right to Non-Discrimination&rdquo; &mdash; If you choose to exercise any of your
            rights under CCPA, AUMHUM will treat you like all other users. In other words, there is
            no penalty for exercising your rights under CCPA.
          </p>
        </li>
      </ul>

      <p>&nbsp;</p>

      <p>
        To exercise any of these rights under CCPA, please email&nbsp;
        <a href="mailto:privacy@aumhum.com">privacy@aumhum.com</a>&nbsp;or write to us at Aumhum
        Pte. Ltd., Attn: Privacy/Legal Team, 160 Robinson Road, #20-03 SBF Center, Singapore 068914.
        As part of the CCPA you may designate an authorized agent to make these requests on your
        behalf. For your protection, we may require that the request be sent through the email
        address associated with your account, and we may need to verify you and/or your
        agent&rsquo;s identity before fulfilling your request.
      </p>

      <p>
        Additionally, for more information about the personal information we collect and how we
        collect it, please see the sections above entitled &ldquo;What Data We Get&rdquo; and
        &ldquo;How We Get Data About You.&rdquo;
      </p>

      <p>
        To learn about the business and commercial purposes for which your personal information is
        collected and the categories of service providers who have access to your personal
        information, please see the sections above entitled &ldquo;What We Use Your Data For&rdquo;
        and &ldquo;Who We Share Your Data With.&rdquo;
      </p>

      <p>
        Most importantly, per the CCPA, AUMHUM does not sell your personal information or the
        personal information of any of our users.
      </p>

      <p>
        As a California resident, you also have the right to request certain details about what
        personal information we share with third parties for those third parties&rsquo; direct
        marketing purposes. To submit your request, send an email to&nbsp;
        <a href="mailto:privacy@aumhum.com">privacy@aumhum.com</a>&nbsp;with the phrase
        &ldquo;California Shine the Light&rdquo; and include your mailing address, state of
        residence, and email address.
      </p>

      <p>
        Since the internet industry is still working on Do Not Track standards, solutions, and
        implementations, we do not currently recognize or respond to browser-initiated Do Not Track
        signals.
      </p>

      <p>​</p>

      <p>7.2 Users in Nevada</p>

      <p>
        As is the case for all of its users, AUMHUM does not sell its users&rsquo; personal
        information or personal data. Nonetheless, if you are a resident of Nevada, and would like
        to request that we do not sell your personal information, you can request to opt out of the
        sale of covered information by emailing&nbsp;
        <a href="mailto:privacy@aumhum.com">privacy@aumhum.com</a>&nbsp;or writing to us at Aumhum
        Pte. Ltd., Attn: Privacy/Legal Team, 160 Robinson Road, #20-03 SBF Center, Singapore 068914
        .
      </p>

      <p>​</p>

      <p>7.3 Users in Australia</p>

      <p>
        If you are an Australia resident and you have a complaint, you may refer it to the office of
        the Australian Information Commissioner (&ldquo;OAIC&rdquo;). You can contact OAIC by
        visiting&nbsp;
        <a href="http://www.oaic.gov.au/" target="_blank" rel="noreferrer">
          www.oaic.gov.au
        </a>
        ; forwarding an email to&nbsp;
        <a href="mailto:enquiries@oaic.gov.au">enquiries@oaic.gov.au</a>; telephoning 1300 363 992;
        or writing to OAIC at GPO Box 5218, Sydney NSW 2001.
      </p>

      <p>​</p>

      <p>7.4 Users Outside of the U.S.</p>

      <p>
        AUMHUM Pte. Ltd., has its cloud storage in the United States, and in order to provide the
        Services to you, we must transfer your data to the United States and process it there. By
        visiting or using our Services, you consent to the storage of your data on servers located
        in the United States. If you are using the Services from outside the United States, you
        consent to the transfer, storage, and processing of your data in and to the United States or
        other countries. Specifically, personal data collected in the United Kingdom
        (&ldquo;UK&rdquo;), Switzerland, and the European Economic Area (&ldquo;EEA&rdquo;) is
        transferred and stored outside those areas. Additionally, if you are located in the UK, EEA,
        or Switzerland, you also have the right to lodge a complaint with your data supervisory
        authority.
      </p>

      <p>
        That data is also processed outside of the UK, Switzerland, and the EEA by our AUMHUM group
        companies, or our service providers, including to process transactions, facilitate payments
        and provide support services as described in Section 4. We have entered into data processing
        agreements with our service providers that restrict and regulate their processing of your
        data on our behalf. By submitting your data or using our Services, you consent to this
        transfer, storage, and processing by AUMHUM and its processors.
      </p>

      <p>​</p>

      <p>8. Updates &amp; Contact Info</p>

      <p>
        When we make a material change to this policy, we&rsquo;ll notify users via email,
        in-product notice, or another mechanism required by law. Changes become effective the day
        they&rsquo;re posted. Please contact us via email or postal mail with any questions,
        concerns, or disputes.
      </p>

      <p>&nbsp;</p>

      <p>8.1 Modifications to This Privacy Policy</p>

      <p>
        From time to time, we may update this Privacy Policy. If we make any material change to it,
        we will notify you via email, through a notification posted on the Services, or as required
        by applicable law. We will also include a summary of the key changes. Unless stated
        otherwise, modifications will become effective on the day they are posted.
      </p>

      <p>​</p>

      <p>
        As permitted by applicable law, if you continue to use the Services after the effective date
        of any change, then your access and/or use will be deemed an acceptance of (and agreement to
        follow and be bound by) the revised Privacy Policy. The revised Privacy Policy supersedes
        all previous Privacy Policies.
      </p>

      <p>​</p>

      <p>8.2 Interpretation</p>

      <p>
        Any capitalized terms not defined in this policy are defined as specified in
        AUMHUM&#39;s&nbsp;
        <a href="https://aumhum.com/terms/" target="_blank" rel="noreferrer">
          Terms of Use
        </a>
        . Any version of this Privacy Policy in a language other than English is provided for
        convenience. If there is any conflict with a non-English version, you agree that the English
        language version will control.
      </p>

      <p>​</p>

      <p>8.3 Questions</p>

      <p>
        If you have any questions, concerns, or disputes regarding our Privacy Policy, please feel
        free to contact our privacy team (including our designated personal information protection
        manager) at&nbsp;<a href="mailto:privacy@aumhum..com">privacy@aumhum..com</a>. You can also
        send postal mail to us at AUMHUM Pte. Ltd., Attn: Privacy/Legal Team, 160 Robinson Road,
        #20-03 SBF Center, Singapore 068914.
      </p>
    </div>
  )
}
